export default {
    rtl: false,
    header: {
        title: 'Your Cart'
    },
    empty_cart: '',
    shipping_option: 'livraison standard',
    product: {
        sold_out: 'Sold Out'
    },
    product_details: {
        atcButton: { text: 'Add To Cart' },
        readMore: { text: 'Read More' }
    },
    modules: {
        checkout_button: {
            button_text: { text: 'Checkout / {{ subtotal }}' },
            button_text_loading: { text: 'Generating Offer...' },
            use_coupon_code: { text: 'Coupon code' },
            enter_coupon_code: { text: 'Enter Coupon Code' },
            apply_coupon_code: { text: 'Apply' },
            edit_coupon_code: { text: 'Edit' },
            close_coupon_code: { text: 'Close' },
            subtotal: { text: 'Subtotal' },
            savings: { text: 'Savings' },
            coupon_alert_text: { text: 'Code overrides offers' }
        },
        random_text: {
            text: '<p class="ql-align-center">100% NO-RISK MONEY BACK GUARANTEE</p>'
        },
        order_note: {
            text: '<p> <strong>Add a note to your order</strong></p>'
        }
    },
    campaigns: {
        bundles: {
            text: 'Buy {{quantity}} save {{discount}}',
            prefix: '{{individual_price}} each'
        },
        add_to_unlock: {
            title: {
                text: 'Frequently Bought Together'
            },

            show_product_details: {
                text: 'Show Details'
            },
            upsell_add_button: {
                text: 'Add To Cart'
            },
            upsell_confirm_button: {
                text: 'Confirm'
            },
            discount: {
                before:
                    "<p class='ql-align-center'><img src='https://monster-upsells-images-prod.s3.us-east-2.amazonaws.com/wp4cb45f10.gif'> Add <b>{{amount_left}}</b> to unlock <b>{{reward}}</b> off<p>",
                after:
                    "<p class='ql-align-center'><img src='https://media.giphy.com/media/1wX5TJZPqVw3HhyDYn/giphy.gif'> You've unlocked <b>{{reward}}</b> off<p>"
            },
            free_shipping: {
                before:
                    "<p class='ql-align-center'><img src='https://monster-upsells-images-prod.s3.us-east-2.amazonaws.com/wp4cb45f10.gif'>  Add <b>{{amount_left}}</b> to get <b>free shipping</b><p>",
                after:
                    "<p class='ql-align-center'><img src='https://media.giphy.com/media/1wX5TJZPqVw3HhyDYn/giphy.gif'> You've unlocked <b>Free shipping!</b><p>"
            },
            separator: {
                text: 'OR'
            },
            gift: {
                before:
                    "<p class='ql-align-center'><img src='https://monster-upsells-images-prod.s3.us-east-2.amazonaws.com/wp4cb45f10.gif'> Add <b>{{amount_left}}</b> to get a <b>Free Gift</b><p>",
                after:
                    "<p class='ql-align-center'><img src='https://media.giphy.com/media/1wX5TJZPqVw3HhyDYn/giphy.gif'> You've unlocked a <b>Free Gift</b><p>",
                compare_at_price: {
                    text: '{{compare_at_price}}'
                },
                widget: {
                    before: {
                        header: '<b>Add {{amount_left}} to unlock Free Gift 🎁</b>',
                        product_name: 'Today only offer',
                        offer_highlight: {
                            text: 'Free'
                        }
                        // variant_selector_text: {
                        // 	text: "Add Gift"
                        // },
                    },
                    selecting: {
                        header: '<b>Select 1 Free Gift</b>',
                        product_name: '{{product_name}}',
                        offer_highlight: {
                            text: 'Free'
                        },
                        variant_selector_text: {
                            text: 'Add Gift'
                        }
                    },
                    after: {
                        header: '<b>You unlocked a Free Gift! 🎉</b>',
                        product_name: '<p>Only valid today! ⏰</p><p>{{product_name}}</p>',
                        offer_highlight: {
                            text: 'Free'
                        },
                        variant_change_text: {
                            text: 'Change gift'
                        }
                    }
                },
                inventory_quantity: {
                    text: 'Only {{inventory_quantity}} left'
                }
            }
        },
        one_check_up_sell: {
            text: '<p>🔥 Add {{title}} For {{price}}</p>'
        }
    }
};
